import { render, staticRenderFns } from "./teskManageODM.vue?vue&type=template&id=990a4f98&"
import script from "./teskManageODM.vue?vue&type=script&lang=ts&"
export * from "./teskManageODM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports